import { tokens } from 'components/v3';

// The entry card and the Columns / Export dialogs use the design's own
// surface palette (submissions.css --sx-*), on top of the v3 text colours.
// One object per theme so styled components and inline styles read the
// same values: sx(theme).card, sx(theme).tint …

const DARK = {
  card: '#1A1A2E',
  inset: '#14142A',
  band: '#16162B',
  line: 'rgba(255, 255, 255, 0.08)',
  line2: 'rgba(255, 255, 255, 0.12)',
  ctl: 'rgba(255, 255, 255, 0.30)',
  hover: 'rgba(255, 255, 255, 0.035)',
  fill: 'rgba(255, 255, 255, 0.07)',
  field: 'rgba(255, 255, 255, 0.04)',
  tint: 'rgba(250, 70, 22, 0.13)',
  tintB: 'rgba(250, 70, 22, 0.40)',
  otext: '#FA4616',
  ok: '#34D27B',
  okBg: 'rgba(31, 157, 87, 0.18)',
  pop: '0 18px 48px rgba(0, 0, 0, 0.5)',
  overlay: 'rgba(0, 0, 0, 0.7)',
  text2: 'rgba(255, 255, 255, 0.78)',
  disabled: 'rgba(255, 255, 255, 0.35)',
  error: '#ED4337',
  errorBg: 'rgba(237, 67, 55, 0.20)',
};

const LIGHT = {
  card: '#FFFFFF',
  inset: '#F3F5F8',
  band: '#EEF2F6',
  line: 'rgba(15, 23, 42, 0.08)',
  line2: 'rgba(15, 23, 42, 0.14)',
  ctl: 'rgba(15, 23, 42, 0.30)',
  hover: 'rgba(15, 23, 42, 0.03)',
  fill: 'rgba(15, 23, 42, 0.06)',
  field: '#FFFFFF',
  tint: 'rgba(250, 70, 22, 0.10)',
  tintB: 'rgba(250, 70, 22, 0.28)',
  otext: '#D63A0F',
  ok: '#16A34A',
  okBg: 'rgba(22, 163, 74, 0.10)',
  pop: '0 18px 48px rgba(23, 37, 69, 0.18)',
  overlay: 'rgba(0, 0, 0, 0.5)',
  text2: '#475569',
  disabled: 'rgba(31, 42, 48, 0.38)',
  error: '#ED4337',
  errorBg: 'rgba(237, 67, 55, 0.10)',
};

// Brand orange, the same in both themes.
export const ORANGE = '#FA4616';

export const sx = (theme) => {
  const t = tokens(theme);
  const surface = theme && theme.name === 'dark' ? DARK : LIGHT;
  return { ...surface, text: t.text, label: t.label, faint: t.faint };
};

export default sx;
